<template>
    <div>

        <div>
            <div class="d-flex flex-column question mb-2">
                <div class="text-muted mr-1 mb-1">Question:</div>
                <TipTap
                    v-model="question.content.question"
                    :menu_items="[]"
                    :readonly="true"
                />
            </div>
        </div>

        <div class="row">
            <div class="col-xl-6 col-xl-mb-0 mb-3">
                <div :style="{'position': 'relative', 'width': 'fit-content'}">
                    <div
                        :class="{
                            'merlin-asset-border': question.content.image && isMerlinMedia(question.content.image.src)
                        }"
                    >
                        <span
                            v-if="question.content.image && isMerlinMedia(question.content.image.src)"
                            class="merlin-asset-warning"
                        >
                            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                            Merlin Asset
                        </span>
                        <b-img
                            :src="question.content.image.src"
                            :height="question.content.image.height"
                            :width="question.content.image.width"

                        />
                    </div>
                    <div v-for="(clue, index) in question.content.clues" :key="index"
                        :style="{'height': clue.hot_area_height+'px',
                             'max-height': clue.hot_area_height+'px',
                             'width': clue.hot_area_width+'px',
                             'max-width': clue.hot_area_width+'px',
                             'position': 'absolute',
                             'top':clue.dot.offsetY+'px',
                             'left': clue.dot.offsetX+'px',
                             'background-color': 'white',
                             'opacity': 0.7
                         }">
                        <div
                        variant="warning"
                        :style="{'background-color': 'grey',
                                 'color': 'white',
                                 'width': '30px',
                                 'height': '30px',
                                 'text-align': 'center',
                                 'position': 'absolute',
                                 'top':clue.dot.offsetY,
                                 'left': clue.dot.offsetY
                                }">
                            {{index + 1}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-6">
                <div v-show="question.content.clues && question.content.clues.length" class="mb-3">
                    <h6>Clues</h6>
                    <b-list-group>
                        <b-list-group-item
                            :class="{'merlin-asset-border': clue.url && isMerlinMedia(clue.url)}"
                            v-for="(clue, index) in question.content.clues"
                            :key="index"
                        >
                            <div v-if="clue.is_empty">
                                {{index + 1}}. (Empty Clue)
                            </div>
                            <div v-else-if="clue.type == 'text'">
                                {{index + 1}}. {{clue.text}}
                            </div>
                            <div v-else
                                class="mb-3"
                                :style="{
                                    'height': '100px',
                                    'max-height': '100px',
                                }"
                            >
                                <span
                                    v-if="clue.url && isMerlinMedia(clue.url)"
                                    class="merlin-asset-warning"
                                >
                                    <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                                    Merlin Asset
                                </span>
                                {{index + 1}}.
                                <b-img
                                    :src="clue.url"
                                    :style="{
                                        'max-height': '100%',
                                        'max-width': '100%',
                                    }"
                                />
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import Vue from 'vue'

Vue.directive('tack', {
    bind (el, binding) {
        el.style.position = 'absolute'
        const s = (binding.arg == 'left' ? 'left' : 'top')
        el.style[s] = binding.value + 'px'
    }
})

export default {
    data: () => ({}),
    props: ['question', 'question_html'],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap')
    },
    methods: {
        saveQuestion () {
            this.$emit('saveQuestion')
        },
        isMerlinMedia(image) {
            return image.toLowerCase().includes('merlinone')
        },
    }
}
</script>
